<template>
  <div id="Haomatongji">
    <div class="tr-header">
      <p class="title">{{betType == 'PK10' ? '今日号码统计':'号码统计'}}</p>
      <div>
        <ColorFiltrate @inputNum="inputNum"></ColorFiltrate>
      </div>
    </div>
    <div class="tr-table-container">
      <Table width="100%" :columns="columns" :data="dataSource" border></Table>
      <span
        class="food_span"
      >使用说明：提供号码当日的开出次数及近期未开次数，使用参数设置可自定义关注遗漏范围，请根据个人需要手动设置，各参数的数值可设置范围是：2-500</span>
    </div>
  </div>
</template>
<script>
import columns from "./columns";
import dayjs from "dayjs";
import format from "../../../helpers/format.js";
import ColorFiltrate from "../../../components/ColorFiltrate";

export default {
  name: "Haomatongji",
  components: {
    ColorFiltrate
  },
  data() {
    return {
      columns: [],
      pageSize: 30,
      dataSource: [],
      minNumOne: 1,
      maxNumOne: 0,
      minNumTwo: 1,
      maxNumTwo: 0,
      minNumThr: 1,
      maxNumThr: 0
    };
  },
  computed: {
    betType() {
      return this.$route.params.betType;
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.getDate();
      }
    }
  },
  methods: {
    inputNum(arr) {
      // console.log(arr, "nnnnnnnnnnn");
      this.minNumOne = arr[0];
      this.maxNumOne = arr[1];
      var len = arr.length;
      if (len == 4) {
        this.minNumTwo = arr[2];
        this.maxNumTwo = arr[3];
      }
      if (len == 6) {
        this.minNumThr = arr[4];
        this.maxNumThr = arr[5];
      }
    },
    reset(data) {
      this.columns = columns(this.betType, data, this.ballIndex).list(this);
      // this.lostColumns = columns(this.betType, data).lostList(this);
    },

    async getDate() {
      let req = {
        gameType: this.$route.params.gameType
        // pageSize: 30,
        // startRow: 0
      };
      let res = await this.$http.post("/queryKcDateReport.do", req);
      if (res.data.returnCode == "0000") {
        var arr = format.formatJson(res.data.returnList);
        var census = this.formatCensus(arr[0].census_json);
        // console.log(census, "arr");

        this.dataSource = census;
        this.reset(census);
      } else {
        this.$Message.error(res.data.returnMessage);
      }
    },
    formatCensus(obj) {
      var a = {};
      var keys = Object.keys(obj);
      var ball = Object.keys(obj[keys[0]]);

      for (let i = 0; i < ball.length; i++) {
        var o = {};
        for (const k in obj) {
          if (obj.hasOwnProperty(k)) {
            const e = obj[k][ball[i]];
            o[k] = e;
          }
        }

        a[ball[i]] = o;
      }
      var keysArr = Object.keys(a).sort(function(a, b) {
        return Number(a) - Number(b);
      });
      var sortObj = [];
      for (var i = 0; i < keysArr.length; i++) {
        var key = keysArr[i];
        sortObj.push(a[key]);
      }
      // console.log(sortObj);
      return sortObj;
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
/deep/.ivu-table-wrapper {
  min-width: 1160px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Haomatongji/index.vue